import * as yup from 'yup';

const validationFields = {
  currentPassword: yup
    .string()
    .required('validations.updatePassword.password.required')
    .min(8, 'validations.updatePassword.password.minLength'),
  password: yup
    .string()
    .required('validations.updatePassword.password.required')
    .min(8, 'validations.updatePassword.password.minLength'),
  passwordConfirmation: yup
    .string()
    .oneOf([yup.ref('password'), null], 'validations.updatePassword.passwordConfirmation.passwordMatch')
    .required('validations.updatePassword.passwordConfirmation.required'),
};

export const validationSchema = yup.object().shape({ ...validationFields });

export const initialValues = {
  currentPassword: '',
  password: '',
  passwordConfirmation: '',
};



// WEBPACK FOOTER //
// ./src/forms/updatePasswordForm.js